<template>
  <div
    class="text-start text-cerise-red-600 bg-lavender-blush-50 mt-12 lg:mt-14 px-6 lg:px-24 py-14 lg:py-20 rounded-md"
  >
    <h1 class="font-bold text-xl lg:text-3xl mb-12">Domande frequenti</h1>

    <div class="space-y-14">
      <VipClubFAQ
        v-for="item in faq"
        :key="item.title"
        :description="item.description"
        :title="item.title"
        :is-homepage="true"
      />
    </div>

    <div class="mt-10 font-bold text-lg lg:text-xl">
      Hai ancora dubbi?
      <nuxt-link
        target="_blank"
        to="https://www.prenatal.com/contact/"
        class="underline inline-block mr-2"
      >
        Clicca qui
      </nuxt-link>
      per trovare le risposte che stai cercando
    </div>
  </div>

  <CoreFidelityNotice />
</template>

<script setup lang="ts">
import { fetchOptions } from '~/composables/options'

const options = await fetchOptions()

const discount = options.discount
const discountDefault = options.discountDefault
const discountPromo = options.discountPromo
const dateEnd = options.dateEnd


function formatDateToIt(dateStr: string) {
  if (!dateStr) return ''
  const date = new Date(dateStr)
  const day = date.getDate()
  let month = date.toLocaleDateString('it-IT', { month: 'long' })
  month = month.charAt(0).toUpperCase() + month.slice(1)
  return `${day} ${month}`

}

const promoLine = discountPromo && discountPromo !== discountDefault && dateEnd &&
  new Date() <= new Date(dateEnd)
    ? `solo fino al ${formatDateToIt(dateEnd)} del ${discountPromo}%`
    : ''

const faq = [
  {
    title:
      "Ho una Prénatal Card attiva, posso partecipare alla raccolta punti del nuovo programma fedeltà Prenatal Lover?",
    description: `Tutte le Prenatal Card registrate prima della partenza del programma sono già abilitate per partecipare alla raccolta punti e ottenere i vantaggi riservati. <br> <a href="/regolamento-programma-fedelta" class="underline inline-block"> Leggi il regolamento qui</a> `,
  },
  {
    title: "Come posso conoscere il saldo punti della mia Card?",
    description: `Puoi conoscere il tuo saldo punti verificandolo direttamente sull’ultimo scontrino, oppure online nella tua area personale disponibile su questo sito.`,
  },
  {
    title: `Qual è la scadenza del buono sconto del ${discountDefault}% ?`,
    description: `
      Il buono sconto unico del ${discountDefault}% <strong>${promoLine}</strong>, è valido su tutto l’abbigliamento e le calzature, in negozio e online. 
      Il buono sconto è cumulabile con eventuali promozioni in corso (esempio “promozione saldi”: lo sconto del ${discountDefault}% <strong>${promoLine}</strong>, si applica al prezzo scontato in saldo). 
      Non è richiesto un minimo di spesa.
      Il buono è utilizzabile entro 90 giorni dalla data di emissione ed è utilizzabile una sola volta. 
      Non è possibile utilizzare più di un buono sconto Prénatal Lover in un singolo scontrino o ordine online.
      ${promoLine ? `<br>` : ''}
    `,
  },
]
</script>
